module.exports = __webpack_public_path__ + "media/images/pc/special_reports/icon_sakura-710bd9b03d8164770789573c61f3eaed.png";